import { z } from 'zod'
import { TicketValidityPeriod } from '~library/enums'
import {
  managerBenefitFileSchema,
  managerBenefitCommonSchema
} from '~library/models'

export const managerBenefitSchema = z
  .object({
    /** 回饋項目Id */
    id: z.string(),
    /** 限時促銷Id */
    flashSaleId: z.string(),
    /** 限量明細Id */
    limitedEditionDetailId: z.string(),
    /** 熱門 */
    popular: z.boolean(),
    /** 限時 */
    flashSale: z.boolean(),
    /** 限量 */
    limitedEdition: z.boolean(),
    /** 售罄 */
    soldOut: z.boolean(),
    /** 原始點數 */
    originalPoint: z.number(),
    /** 點數 */
    point: z.number(),
    /** 使用效期[天] */
    validityPeriod: z.union([
      z.nativeEnum(TicketValidityPeriod),
      // 購票優惠碼會回 '0'
      z.literal('0'),
      z.null()
    ]),
    /** 檔案 */
    file: z.array(managerBenefitFileSchema)
  })
  .merge(managerBenefitCommonSchema)

export interface ManagerBenefit extends z.infer<typeof managerBenefitSchema> {}
